var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement, memo, useState, useEffect, useRef, useCallback } from '@max/max';
import View from '@hfe/max-view';
import Sensor from '@max/mbc-sensor';
import Button from '@hfe/max-button';
import Text from '@hfe/max-text';
import Image from "@max/leez-image";
import { PrizeStatus, RewardType, ActivityState, TaskType } from './types';
import { setCustomTheme } from '@max/leez-context';
import { hotelTheme } from '@max/leez-theme-hotel';
import { setRemConfig } from '@max/leez-style-util';
import { useMonitorEngineContext, useMonitorNavigation } from '@nibfe/mcp-monitor-sdk';
import { useDraw, useQueryActivityInfo, useQueryTaskCompleteStatus, useJoinActivity } from './apis';
import CouponUsageRecord from './components/coupon-usage-record';
import RewardCouponPackage from './components/reward-coupon-package';
import PackagePrizeModal from './components/package-prize-modal';
import CommonPrizeModal from './components/common-prize-modal';
import NoPrizeModal from './components/no-prize-modal';
import './index.scss';
import SlotMachine from './components/slot-machine';
import OperateBtns from './components/operate-btns';
import { REEL_IMAGE, POINTER_VAP, BID_MAP, BID_TYPE, COMPLETE_TASK_ERROR_CODE_DESC, TRIGGER_DRAW_EVENT, SHARE_BUTTON_TYPE, JOIN_SUCCESS_GIF_URL, JOIN_SUCCESS_GIF_DURATION } from './constants';
import { getPlatformType, isMeituanAppOrWebview, PlatformType } from '@nibfe/mkt-env-api';
import { generateStateFromDrawModule, getCouponPackageInDraw, getCanRewardPrizeInfo, getRewardPrizeInfoRecord } from './utils';
import { convertLinkToAppMiddleOpenLink, getQueryParams } from './utils/common';
import prefetchImage from './utils/prefetchImage/index';
import { useDebounce } from './hooks/useDebounce';
import { useShare } from "./hooks/useShare/useShare.web";
import VapView from '@/components/vap-view';
import { SubscribeStatus } from './components/subscribe-button';
const isWeb = true;
import { rpx2px } from '@hfe/max-universal-unit-tool';
import { ShareType } from './hooks/useShare/types';
import GifAnimView from './components/gif-anim-view';
setRemConfig({
    enabled: true
});
setCustomTheme(hotelTheme);
const PeriodicRewardClaim = (props) => {
    const { activityId, anchorKey, subscribeConfig, shareConfig, styleConfig, realPackagePrizeUuids = [] } = props;
    // 处理老虎机奖励图片：将对象转换成数组，优先使用配置值，兜底使用 REEL_IMAGE
    const reelImages = (() => {
        if (styleConfig === null || styleConfig === void 0 ? void 0 : styleConfig.reelImages) {
            const { reel1, reel2, reel3, reel4, reel5 } = styleConfig.reelImages;
            const configuredImages = [reel1, reel2, reel3, reel4, reel5].filter(img => img);
            if (configuredImages.length === 5) {
                return [reel1, reel2, reel3, reel4, reel5];
            }
        }
        return REEL_IMAGE;
    })();
    const ctx = useMonitorEngineContext();
    const { leaderId, taskId, taskType } = getQueryParams(ctx);
    const { monitorNavigateTo } = useMonitorNavigation();
    const { request: queryActivityInfo } = useQueryActivityInfo();
    const { request: queryTaskCompleteInfo } = useQueryTaskCompleteStatus();
    const { request: handleDrawPrize } = useDraw();
    const { request: joinActivity } = useJoinActivity();
    const { shareWXCard } = useShare(ShareType.H5_LINK);
    const [drawModuleInfo, setDrawModuleInfo] = useState(null);
    const [canRewardPrizeInfos, setCanRewardPrizeInfos] = useState([]);
    const [hasAppointment, setHasAppointment] = useState(false);
    // const [userPrizeInfo, setUserPrizeInfo] = useState<UserPrizeInfo | null>(null); // 抽奖结果
    const leadTaskId = useRef(null);
    const leadTaskType = useRef(null);
    const [modalVisible, setModalVisible] = useState(false);
    const [prizeList, setPrizeList] = useState([]);
    const [prizeModalVisible, setPrizeModalVisible] = useState(false);
    const [commonPrizeModalVisible, setCommonPrizeModalVisible] = useState(false);
    const [noPrizeModalVisible, setNoPrizeModalVisible] = useState(false);
    const [selectedPrize, setSelectedPrize] = useState(null);
    const [slotMachineSpinController, setSlotMachineSpinController] = useState(0);
    const spinRunning = useRef(false); // 标记抽奖流程是否进行中（包括接口调用和动画）
    const [activityState, setActivityState] = useState(ActivityState.CAN_RESERVE); // 这个字段只有在抽奖时间内有效
    const slotMachineRef = useRef(null);
    const [showPointerVap, setShowPointerVap] = useState(false);
    // 使用 Ref 缓存接口结果，确保老虎机结束时能同步读取（不依赖 setState 时序）
    const drawResultRef = useRef(null);
    // 老虎机中奖位置 state
    const [winningIndexes, setWinningIndexes] = useState([4, 4, 4, 4, 4]);
    // 如果当前属于抽奖时间，需要找出是否已经抽中过奖励包，奖励包需要在抽奖时段展示出来
    const [packagePrize, setPackagePrize] = useState(null);
    // 主页面 gif 动效播放完成状态
    const [mainVapVideoEnded, setMainVapVideoEnded] = useState(false);
    // 主动塞券是否成功（控制 gif 动效是否展示）
    const [joinActivitySuccess, setJoinActivitySuccess] = useState(false);
    const joinActivityCalledRef = useRef(false); // 防止重复调用
    // 组件挂载时预加载 gif，减少展示时的加载延迟
    useEffect(() => {
        prefetchImage(JOIN_SUCCESS_GIF_URL);
    }, []);
    // 监听 drawModuleInfo 变化，更新 packagePrize
    useEffect(() => {
        if (!drawModuleInfo) {
            // setPackagePrize(null);
            return;
        }
        setPackagePrize(getCouponPackageInDraw(drawModuleInfo, realPackagePrizeUuids));
    }, [drawModuleInfo]);
    // 查询活动信息
    const fetchActivityInfo = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            const data = yield queryActivityInfo({
                activityId,
                scene: 1
            });
            if ((data === null || data === void 0 ? void 0 : data.moduleInfoList) && Array.isArray(data.moduleInfoList)) {
                // 从模块列表中找到抽奖模块
                const drawModule = data.moduleInfoList.find(module => module === null || module === void 0 ? void 0 : module.lotteryModuleInfo);
                if (drawModule === null || drawModule === void 0 ? void 0 : drawModule.lotteryModuleInfo) {
                    const activityState = generateStateFromDrawModule(drawModule.lotteryModuleInfo, drawModule.hasNextDrawTime, realPackagePrizeUuids);
                    const canRewardPrizeInfos = getCanRewardPrizeInfo(drawModule.rewardModuleInfoVO);
                    const rewardPrizeInfoList = getRewardPrizeInfoRecord(drawModule.rewardModuleInfoVO);
                    const prizes = Array.isArray(drawModule.lotteryModuleInfo.userPrizeInfos) ? drawModule.lotteryModuleInfo.userPrizeInfos : [];
                    setActivityState(activityState);
                    setDrawModuleInfo(drawModule.lotteryModuleInfo);
                    setCanRewardPrizeInfos(canRewardPrizeInfos);
                    setPrizeList([...prizes, ...rewardPrizeInfoList]);
                    const lotteryModuleInfo = drawModule.lotteryModuleInfo;
                    const { inDrawTime, currentDrawTimeStart, currentDrawTimeEnd } = lotteryModuleInfo;
                    if ((drawModule === null || drawModule === void 0 ? void 0 : drawModule.taskListModuleInfo) && inDrawTime && currentDrawTimeStart && currentDrawTimeEnd) {
                        const currentTask = (_a = drawModule.taskListModuleInfo.taskInfos) === null || _a === void 0 ? void 0 : _a.find((item) => {
                            const isInviteTask = item.taskType === TaskType.INVITE_TASK;
                            // 可能存在多个分时间段的助力任务，选取与当前抽奖时间段有交集的任务
                            if (isInviteTask) {
                                const { startTime, endTime } = item;
                                // 判断任务时间段与活动时间段是否有交集
                                // 两个时间段有交集的条件：任务开始时间 < 活动结束时间 && 任务结束时间 > 活动开始时间
                                console.log('time', '活动:', new Date(currentDrawTimeStart).toLocaleString(), '-', new Date(currentDrawTimeEnd).toLocaleString(), '| 任务:', new Date(startTime).toLocaleString(), '-', new Date(endTime).toLocaleString());
                                if (startTime && endTime && currentDrawTimeStart && currentDrawTimeEnd) {
                                    const hasIntersection = startTime < currentDrawTimeEnd && endTime > currentDrawTimeStart;
                                    console.log('是否有交集:', hasIntersection);
                                    return hasIntersection;
                                }
                            }
                            return false;
                        });
                        leadTaskId.current = (currentTask === null || currentTask === void 0 ? void 0 : currentTask.taskId) || null;
                        leadTaskType.current = (currentTask === null || currentTask === void 0 ? void 0 : currentTask.taskType) || null;
                        // console.log('taskId', leadTaskId.current, leadTaskType.current);
                    }
                }
                else {
                    // 如果没有找到抽奖模块，重置数据
                    setDrawModuleInfo(null);
                    setPrizeList([]);
                    setActivityState(ActivityState.END);
                }
            }
            else {
                // 如果响应数据不合法，重置数据
                setDrawModuleInfo(null);
                setPrizeList([]);
                setActivityState(ActivityState.END);
            }
        }
        catch (error) {
            console.error('查询活动信息失败>>:', error);
            // 错误情况下保持当前状态或重置
            setDrawModuleInfo(null);
            setPrizeList([]);
            setActivityState(ActivityState.END);
        }
    }), [activityId]);
    // 创建防抖版本的 fetchActivityInfo，延迟 1 秒执行
    const debouncedFetchActivityInfo = useDebounce(fetchActivityInfo, 1000);
    // activityState 变为 UNRESERVED_CAN_DRAW 时，调用参与活动/主动塞券接口
    useEffect(() => {
        if (activityState === ActivityState.UNRESERVED_CAN_DRAW && !joinActivityCalledRef.current && canRewardPrizeInfos.length) {
            const prizeBatchId2TypeMap = canRewardPrizeInfos.reduce((acc, item) => {
                acc[item.prizeBatchId] = item.rewardType;
                return acc;
            }, {});
            handleDrawPrize({
                drawParam: {
                    prizeBatchId2TypeMap,
                    moduleType: 6,
                    // 领奖模块
                    drawExtraInfo: {
                        scene: 1
                    }
                },
                activityId,
                activityName: String(activityId)
            }).then(data => {
                // 请求成功后才标记为已调用，防止重复请求
                joinActivityCalledRef.current = true;
                // userPrizeInfos有值，券塞入成功，展示 gif 动效，并刷新活动信息
                if (data && Array.isArray(data.userPrizeInfos) && data.userPrizeInfos.length) {
                    setJoinActivitySuccess(true);
                    debouncedFetchActivityInfo();
                }
                else {
                    setJoinActivitySuccess(false);
                }
            }).catch(() => {
                // 请求失败时不标记，允许下次状态变化时重试
                setJoinActivitySuccess(false);
            });
        }
    }, [activityState, canRewardPrizeInfos]);
    // 抽奖
    const drawPrize = useDebounce(() => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        // ✅ 检查是否正在抽奖流程中（包括接口调用和动画）
        if (spinRunning.current) {
            console.log('抽奖进行中，请勿重复点击');
            return;
        }
        handleReset();
        // ✅ 标记抽奖流程开始（接口调用 + 动画）
        spinRunning.current = true;
        try {
            const data = yield handleDrawPrize({
                drawParam: {
                    moduleType: 3,
                    // 抽奖模块
                    drawExtraInfo: {
                        scene: 1
                    }
                },
                activityId,
                activityName: String(activityId)
            });
            if (data && Array.isArray(data.userPrizeInfos) && data.userPrizeInfos.length) {
                const { userPrizeInfos } = data;
                if (userPrizeInfos[0] && userPrizeInfos[0].rewardType) {
                    // console.log('抽奖结果:', userPrizeInfos[0]);
                    // ✅ 立即缓存到 Ref，老虎机结束时能同步读取（不等 setState 完成）
                    drawResultRef.current = userPrizeInfos[0];
                    // ✅ 根据奖品类型设置 winningIndexes
                    switch (userPrizeInfos[0].rewardType) {
                        case RewardType.Package:
                            if (realPackagePrizeUuids.includes(userPrizeInfos[0].uuid)) {
                                setWinningIndexes([4, 4, 4, 4, 4]); // 奖励包
                            }
                            else {
                                setWinningIndexes([8, 8, 8, 8, 8]); // 非5折券最终停留位置
                            }
                            break;
                        case RewardType.God:
                        case RewardType.Next:
                            setWinningIndexes([8, 8, 8, 8, 8]); // 非5折券最终停留位置
                            break;
                        default:
                            setWinningIndexes([4, 4, 4, 4, 4]);
                    }
                }
            }
            else {
                drawResultRef.current = null;
                setWinningIndexes([8, 8, 8, 8, 8]); // 未中奖默认位置
            }
            // ✅ 设置 winningIndexes 后，等待下一个 tick 再启动动画
            setTimeout(() => {
                startSpin();
            }, 0);
        }
        catch (error) {
            console.error('抽奖失败>>:', error);
            drawResultRef.current = null;
            // ✅ 失败时重置状态标记
            spinRunning.current = false;
            // 显示失败提示
            (_b = ctx === null || ctx === void 0 ? void 0 : ctx._uiInteractionAPI) === null || _b === void 0 ? void 0 : _b.toast.show({
                content: '抽奖失败,请稍后重试'
            });
        }
    }), 500);
    useEffect(() => {
        var _a, _b;
        if (leaderId && taskId) {
            // 客态打开页面
            queryTaskCompleteInfo({
                activityId,
                leaderId,
                taskId,
                taskType: taskType || TaskType.INVITE_TASK,
                followerId: (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.commonParams) === null || _b === void 0 ? void 0 : _b.userId
            }).then((res) => {
                var _a, _b, _c, _d;
                // console.log('queryTaskCompleteInfo', res);
                const status = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.status;
                const data = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.data;
                if (status === 0 && (data === null || data === void 0 ? void 0 : data.taskInstanceId)) {
                    // 助力成功
                    (_c = ctx === null || ctx === void 0 ? void 0 : ctx._uiInteractionAPI) === null || _c === void 0 ? void 0 : _c.toast.show({
                        content: '助力成功~'
                    });
                }
                else {
                    // 助力失败，根据错误码显示提示
                    const errorCode = status;
                    const errorDesc = COMPLETE_TASK_ERROR_CODE_DESC[errorCode];
                    const message = errorDesc ? `助力失败，${errorDesc}` : '助力失败~';
                    (_d = ctx === null || ctx === void 0 ? void 0 : ctx._uiInteractionAPI) === null || _d === void 0 ? void 0 : _d.toast.show({
                        content: message
                    });
                }
            }).catch(() => {
                var _a;
                (_a = ctx === null || ctx === void 0 ? void 0 : ctx._uiInteractionAPI) === null || _a === void 0 ? void 0 : _a.toast.show({
                    content: '助力失败~'
                });
            });
        }
        fetchActivityInfo();
    }, [activityId]);
    const shouldShowPointerVap = useCallback((state, hasAppt) => {
        if (state === ActivityState.REWARD_PACKAGE)
            return false;
        const canDraw = state === ActivityState.UNRESERVED_CAN_DRAW || state === ActivityState.DRAWN_HAS_CHANCES;
        const noAppointmentAllowed = !hasAppt && state !== ActivityState.DRAWN_NO_CHANCES;
        return canDraw || noAppointmentAllowed;
    }, []);
    useEffect(() => {
        setShowPointerVap(shouldShowPointerVap(activityState, hasAppointment));
    }, [activityState, hasAppointment, shouldShowPointerVap]);
    useEffect(() => {
        var _a;
        (_a = ctx._eventInstance) === null || _a === void 0 ? void 0 : _a.on('BASE_ENGINE.ON_PAGE_RELOAD', fetchActivityInfo);
        return () => {
            var _a;
            (_a = ctx._eventInstance) === null || _a === void 0 ? void 0 : _a.off('BASE_ENGINE.ON_PAGE_RELOAD', fetchActivityInfo);
        };
    }, []);
    const handleAnchor = () => {
        var _a;
        anchorKey && ((_a = ctx === null || ctx === void 0 ? void 0 : ctx._uiInteractionAPI) === null || _a === void 0 ? void 0 : _a.anchor.scrollToAnchor({
            anchorKey,
            animated: true
        }));
        // 定位到锚点后，关闭触发该函数的弹窗
        setPrizeModalVisible(false);
        setSelectedPrize(null);
    };
    const handleSubscribeStatusChange = (status) => {
        setHasAppointment(status === SubscribeStatus.SUBSCRIBED);
    };
    const handleSubscribed = () => {
        fetchActivityInfo();
    };
    // 打开奖励记录弹窗
    const handleOpenModal = () => {
        lxReport(BID_MAP.RECORD_BUTTON_MC, BID_TYPE.MC);
        setModalVisible(true);
    };
    const handleCloseModal = () => {
        setModalVisible(false);
    };
    // 5折弹窗
    const handleOpenPrizeModal = (prize) => {
        setSelectedPrize(prize);
        setPrizeModalVisible(true);
    };
    const handleClosePrizeModal = () => {
        setPrizeModalVisible(false);
        setSelectedPrize(null);
    };
    const handleOpenCommonPrizeModal = (prize) => {
        setSelectedPrize(prize);
        setCommonPrizeModalVisible(true);
    };
    // 阳光普照奖
    const handleCloseCommonPrizeModal = () => {
        setCommonPrizeModalVisible(false);
        setSelectedPrize(null);
    };
    // 未中奖弹窗
    const handleOpenNoPrizeModal = () => {
        setNoPrizeModalVisible(true);
    };
    const handleCloseNoPrizeModal = () => {
        setNoPrizeModalVisible(false);
    };
    const startSpin = () => {
        setSlotMachineSpinController(slotMachineSpinController + 1);
    };
    const handleReset = () => {
        var _a;
        // 重置抽奖机状态
        (_a = slotMachineRef.current) === null || _a === void 0 ? void 0 : _a.resetSpin();
        // setUserPrizeInfo(null);
    };
    const onSlotMachineEnd = () => {
        var _a;
        spinRunning.current = false;
        const prizeResult = drawResultRef.current;
        // console.log('onSlotMachineEnd', prizeResult);
        if (prizeResult) {
            // setUserPrizeInfo(prizeResult);
        }
        else {
            // 未中奖
            handleOpenNoPrizeModal();
            fetchActivityInfo(); // 更新活动状态
            return;
        }
        const { rewardType } = prizeResult;
        // 根据奖励类型打开对应的弹窗
        switch (rewardType) {
            case RewardType.Package:
                // 奖励包
                handleOpenPrizeModal(prizeResult);
                break;
            case RewardType.God:
            case RewardType.Next:
                // God券或Next券
                handleOpenCommonPrizeModal(prizeResult);
                break;
            default:
                // 其他类型的奖励，暂不处理
                break;
        }
        (_a = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _a === void 0 ? void 0 : _a.emit('hotelRefreshApi'); // 中奖后触发接口刷新
        fetchActivityInfo(); // 更新活动状态
        drawResultRef.current = null;
    };
    const goToUse = (prize) => {
        var _a, _b, _c;
        // 上报领取点击埋点
        lxReport(BID_MAP.RECORD_TO_USE_MC, BID_TYPE.MC, {
            item_names: prize.prizeBatchId,
            status: prize.prizeStatus
        });
        if (prize.prizeStatus === PrizeStatus.NOT_USED || prize.prizeStatus === PrizeStatus.DRAWN) {
            // 去使用
            let url = prize.jumpUrl;
            if (!url) {
                if (!prize.rewardType) {
                    ctx._uiInteractionAPI.toast.show({
                        content: '跳转失败'
                    });
                    return;
                }
                const mapper = {
                    [RewardType.Next]: {
                        [PlatformType.mtMinaWebview]: '/hotel/pages/list/index',
                        [PlatformType.mtHotelMinaWebview]: '/pages/list/index',
                        [PlatformType.mtApp]: 'imeituan://www.meituan.com/hotel/list',
                        [PlatformType.mtAppWebView]: 'imeituan://www.meituan.com/hotel/list'
                    },
                    [RewardType.God]: {
                        [PlatformType.mtMinaWebview]: '/hotel/pages/list/index',
                        [PlatformType.mtHotelMinaWebview]: '/pages/list/index',
                        [PlatformType.mtApp]: 'imeituan://www.meituan.com/hotel/list',
                        [PlatformType.mtAppWebView]: 'imeituan://www.meituan.com/hotel/list'
                    },
                    [RewardType.Points]: {
                        [PlatformType.mtMinaWebview]: '/hotel/pages/list/index?preCheckedFast={"service_info_poi":"803343"}',
                        [PlatformType.mtHotelMinaWebview]: '/pages/list/index?preCheckedFast={"service_info_poi":"803343"}',
                        [PlatformType.mtApp]: 'imeituan://www.meituan.com/hotel/list?_page_new=1&dsp_init_mrn=1&service_info_poi=803343',
                        [PlatformType.mtAppWebView]: 'imeituan://www.meituan.com/hotel/list?_page_new=1&dsp_init_mrn=1&service_info_poi=803343'
                    }
                };
                const platform = getPlatformType();
                const type = prize.rewardType;
                url = ((_a = mapper[type]) === null || _a === void 0 ? void 0 : _a[platform]) || '';
            }
            if (url) {
                if (isMeituanAppOrWebview()) {
                    monitorNavigateTo({
                        url,
                        _web: {
                            miniProgramNative: true
                        },
                        _meituan: {
                            enableElinkLog: true // 开启 Elink 日志上报
                        }
                    });
                }
                else {
                    monitorNavigateTo({
                        url: convertLinkToAppMiddleOpenLink(url),
                        _web: {
                            miniProgramNative: true
                        },
                        _meituan: {
                            enableElinkLog: true // 开启 Elink 日志上报
                        }
                    });
                }
            }
            else {
                // 上报没有跳转链接的奖励
                (_c = (_b = ctx === null || ctx === void 0 ? void 0 : ctx._raptorReport) === null || _b === void 0 ? void 0 : _b.monitorReportLog) === null || _c === void 0 ? void 0 : _c.call(_b, '没有跳转链接的奖励', {
                    prizeBatchId: prize.prizeBatchId
                }, {
                    category: 'crowdCoupon',
                    level: 'error'
                });
            }
            return;
        }
    };
    // 倒计时结束回调
    const handleCountdownEnd = () => {
        // 可以在这里添加其他逻辑，如刷新页面、显示提示等
        debouncedFetchActivityInfo();
    };
    const lxReport = (bid, bidType, extraVal) => {
        var _a, _b, _c, _d;
        try {
            const { hotelchannel } = (((_a = ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.queryParams) || {});
            const lxCommonParams = {
                hotel_channel: hotelchannel,
                activity_id: activityId
            };
            const valLab = extraVal ? Object.assign(Object.assign({}, lxCommonParams), extraVal) : lxCommonParams;
            switch (bidType) {
                case BID_TYPE.MV:
                    (_b = ctx === null || ctx === void 0 ? void 0 : ctx._LXReport) === null || _b === void 0 ? void 0 : _b.mvReport(bid, {
                        valLab
                    });
                    break;
                case BID_TYPE.MC:
                    (_c = ctx === null || ctx === void 0 ? void 0 : ctx._LXReport) === null || _c === void 0 ? void 0 : _c.mcReportWithTag(bid, {
                        valLab
                    });
                    break;
                case BID_TYPE.MC_WITH_TAG:
                    (_d = ctx === null || ctx === void 0 ? void 0 : ctx._LXReport) === null || _d === void 0 ? void 0 : _d.mcReportWithTag(bid, {
                        valLab
                    });
                    break;
            }
        }
        catch (error) {
            ctx._raptorReport.reportLog('上报埋点异常', error, {
                category: 'jsError',
                level: 'warn',
                tags: {
                    bid
                }
            });
        }
    };
    const handleShare = (type) => {
        var _a;
        if (!shareConfig || !(shareConfig === null || shareConfig === void 0 ? void 0 : shareConfig.url))
            return;
        // console.log('handleShare', shareConfig)
        const { userId } = ((_a = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.commonParams) || {};
        lxReport(BID_MAP.SHARE_BUTTON_MC, BID_TYPE.MC, {
            type
        });
        if (!userId) {
            console.error('handleShare userId is null');
            return;
        }
        ;
        shareWXCard({
            shareConfig: {
                shareUrl: `${shareConfig.url}&leaderId=${userId}&taskId=${leadTaskId.current}&taskType=${leadTaskType.current}`,
                shareContent: shareConfig.description,
                shareTitle: shareConfig.title,
                shareImg: shareConfig.imageUrl
            }
        });
    };
    // @ts-ignore
    if (window === null || window === void 0 ? void 0 : window.inEditor) {
        return <Image source={{
            uri: 'https://img.meituan.net/makerjiulv/dea662bb10c4f2e8bf082652e8e8299b76315.png'
        }} style={{
            width: '702rpx',
            height: '407rpx',
            display: 'flex',
            margin: '0 auto'
        }} borderRadius={rpx2px(36)}/>;
    }
    if (!drawModuleInfo)
        return null;
    return <Sensor className="periodic-reward-claim-container" once onAppear={() => {
        lxReport(BID_MAP.MODULE_MV, BID_TYPE.MV);
    }}>
      <Image x-if={activityState !== ActivityState.END} source={{
        uri: packagePrize ? styleConfig.packageBackgroundImage || 'https://p0.meituan.net/ingee/3c1c21f212ff259bca96bb420891460b12414.png' : styleConfig.backgroundImage
    }} className="claim-container" height={packagePrize ? rpx2px(226) : rpx2px(405)} width={rpx2px(702)} borderRadius={rpx2px(36)}>
        
        <View className="title-container">
          <Text className="title-text" style={{
        fontSize: packagePrize ? '28rpx' : '32rpx'
    }}>
            {packagePrize ? styleConfig.packageTitle || '已获得半价出游券包' : styleConfig.title}
          </Text>
          
          <Button onPress={handleOpenModal} className="rewards-list-open-btn">
            <Text className="rewards-list-open-btn-text">奖励记录</Text>
            <Image source={{
        uri: 'https://p0.meituan.net/ingee/hs/f085fb28479533d84ef9a80da0de2946363.png'
    }} resizeMode="contain" style={{
        width: '20rpx',
        height: '20rpx',
        borderRadius: 0
    }}/>
          </Button>
        </View>
        <RewardCouponPackage x-if={packagePrize} prize={packagePrize} onGoToUse={handleAnchor} lxReport={lxReport}/>
        
        <SlotMachine x-if={!packagePrize} ref={slotMachineRef} style={{
        marginBottom: '18rpx'
    }} reelImage={reelImages} winningIndexes={winningIndexes} onStart={() => { }} onEnd={onSlotMachineEnd} slotMachineSpinController={slotMachineSpinController}/>
        
        <View style={{
        position: 'relative'
    }}>
          <OperateBtns state={activityState} activityId={activityId} drawModuleInfo={drawModuleInfo} subscribeConfig={subscribeConfig} onShare={() => handleShare(SHARE_BUTTON_TYPE.MAIN_SHARE)} onDraw={drawPrize} onCountdownEnd={handleCountdownEnd} onSubscribeStatusChange={handleSubscribeStatusChange} onSubscribed={handleSubscribed} lxReport={lxReport} vapVideoEnded={mainVapVideoEnded} onBounceAnimEnd={() => setJoinActivitySuccess(false)}/>
          <View x-if={showPointerVap} style={{
        position: 'absolute',
        bottom: '-40rpx',
        right: '-20rpx'
    }} onClick={() => {
        var _a;
        // 点击 VapView 时，通过事件总线触发抽奖
        (_a = ctx === null || ctx === void 0 ? void 0 : ctx._eventInstance) === null || _a === void 0 ? void 0 : _a.emit(TRIGGER_DRAW_EVENT);
    }}>
            <VapView {...POINTER_VAP} widthHeightRatio={1} height={isWeb ? 120 : 60} width={isWeb ? 120 : 60} style={{
        pointerEvents: 'none' // VapView 本身不拦截事件
    }} keepLastFrame loop={true}/>
          </View>
        </View>

        
        <CouponUsageRecord x-if={modalVisible} modalVisible={modalVisible} dataList={prizeList !== null && prizeList !== void 0 ? prizeList : []} onCloseModal={handleCloseModal} goToUse={goToUse}/>

        
        <PackagePrizeModal visible={prizeModalVisible} prize={selectedPrize} realPackagePrizeUuids={realPackagePrizeUuids} onClose={handleClosePrizeModal} goToAnchor={handleAnchor} onGoToUse={goToUse} lxReport={lxReport}/>

        <CommonPrizeModal visible={commonPrizeModalVisible} prize={selectedPrize} onClose={handleCloseCommonPrizeModal} onGoToUse={goToUse} lxReport={lxReport}/>

        
        <NoPrizeModal visible={noPrizeModalVisible} onClose={handleCloseNoPrizeModal} onClick={() => handleShare(SHARE_BUTTON_TYPE.MODAL_SHARE)} lxReport={lxReport}/>
      </Image>
      
      <GifAnimView x-if={joinActivitySuccess} gifUrl={JOIN_SUCCESS_GIF_URL} duration={JOIN_SUCCESS_GIF_DURATION} onEnd={() => {
        setMainVapVideoEnded(true);
    }}/>
    </Sensor>;
};
export default memo(PeriodicRewardClaim);
